var id=0;export default function generateKey(){return"mmui-".concat(id++)}